import { render } from "./NoApplications.vue?vue&type=template&id=6c4bf435&ts=true"
import script from "./NoApplications.vue?vue&type=script&lang=ts"
export * from "./NoApplications.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__